/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WorkPackageCategoryDtoPage } from '../../models/work-package-category-dto-page';

export interface ListWorkPackageCategories$Params {
  projectId: string;
  query?: string;
  isActive?: boolean | null;
  excludeIds?: Array<string>;
  group?: string;
  groupEmpty?: boolean | null;
  offset?: number;
  limit?: number;
  sorting?: Array<'id' | '-id' | 'name' | '-name' | 'projectId' | '-projectId' | 'isActive' | '-isActive' | 'color' | '-color' | 'group' | '-group' | 'createdAt' | '-createdAt' | 'updatedAt' | '-updatedAt' | 'workPackagesCount' | '-workPackagesCount'>;
}

export function listWorkPackageCategories(http: HttpClient, rootUrl: string, params: ListWorkPackageCategories$Params, context?: HttpContext): Observable<StrictHttpResponse<WorkPackageCategoryDtoPage>> {
  const rb = new RequestBuilder(rootUrl, listWorkPackageCategories.PATH, 'get');
  if (params) {
    rb.query('projectId', params.projectId, {});
    rb.query('query', params.query, {});
    rb.query('isActive', params.isActive, {});
    rb.query('excludeIds', params.excludeIds, {});
    rb.query('group', params.group, {});
    rb.query('groupEmpty', params.groupEmpty, {});
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('sorting', params.sorting, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<WorkPackageCategoryDtoPage>;
    })
  );
}

listWorkPackageCategories.PATH = '/v0/workPackageCategories';
